/* eslint-disable react/jsx-pascal-case */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Created by tan-qui on 26/04/2022
 */
import i18n from "i18next";
import moment from "moment";
import React, { FC, useEffect, useState } from "react";
import { initReactI18next } from "react-i18next";
import { ConnectedProps, connect } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { FILTER_BACKGROUND, OWNER_TYPE, SUBSOURCE, TYPE_CAMMAND_W2A, VersionEnum, } from "../constant";
import { utils } from "../helpers/util";
import { TRANSLATE } from "../assets/translation";
import Loading from "../components/Loading";
import { KeyVmDto } from "../dto/vending/KeyVmDto";
import W2A from "../layout/Footer/W2A";
import appRouter from "../routers/app.router";
import vendingmachineActions from "../store/vendingmachine/vendingmachine.actions";
import "../assets/css/less/main.less";
import "../assets/css/scss/main.scss";
import CartItem from "../dto/vending/CartItemDto";
import { RootState } from "../store/app.reducer";
import cartActions from "../store/cart/cart.actions";
import AndroidConnect from "./AndroidConnect";
import { history } from "routers/nav.history";
import PageNotFound from "./PageNotFound";
import HanldeWebStomp from "./HanldeWebStomp";

let timeIdAlive = undefined;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      vi: {
        translation: {
          ...TRANSLATE.vi,
        },
      },
      en: {
        translation: {
          ...TRANSLATE.en,
        },
      },
    },
    lng: "vi",
    fallbackLng: "vi",
    interpolation: {
      escapeValue: false,
    },
  });

export const i18nContanst = i18n;

const mapStateToProps = (state: RootState) => ({
  vendingInfo: state.vendingMachineReducer.vendingInfo,
  isLoading: state.vendingMachineReducer.isLoading,
  advertiseList: state.vendingMachineReducer.advertiseList,
});

const faviconMap = {
  "localhost": "/favicons/favicon_bo.ico",
  "payment.blueoceanlaundry.vn": "/favicons/favicon_bo.ico",
  "vending-blueoceanlaundry-korogo-qa.kootoro.com": "/favicons/favicon_bo.ico",
};

const mapDispatchToProps = {
  updateCachedCart: cartActions.updateWholeCart,
  updateStatusVM: vendingmachineActions.updateStatusVM,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & {};

const App: FC<Props> = (props: Props) => {
  /**
   * All properties
   */
  let {
    isLoading,
    vendingInfo,
    advertiseList,
    updateCachedCart,
    updateStatusVM,
  } = props;

  // init custom history object to allow navigation from 
  // anywhere in the react app (inside or outside components)
  const navigate = useNavigate();
  const location = useLocation();
  history.navigate = navigate;
  history.location = location;

  /**
   * Query data
   */
  const query = new URLSearchParams(window.location.search);
  const code = query.get("code") || query.get("vmCode");
  const subsource = query.get("subsource");
  const method = query.get("method");
  const paymentMethod = query.get("paymentMethod");
  const token = query.get("token");
  const lang = query.get("lang");
  const voucherCode = query.get("voucherCode");
  const voucherSource = query.get("voucherSource");
  const privateKey = query.get("privateKey");
  // Đối tác
  const partnerCode = query.get("partnerCode");
  const transactionCode = query.get("transactionCode");
  const requestTime = query.get("requestTime");
  const signature = query.get("signature");

  const voucherByGame = query.get("voucherByGame");

  let [styleUrl, setStyleUrl] = useState<any>(undefined);
  /**
   * Effects
   */
  useEffect(() => {
    var data: any = {};
    let codeStorage = localStorage.getItem("code");
    let privateKeyStore = localStorage.getItem("privateKey");
    if (code != codeStorage) {
      localStorage.removeItem(`vendingInfo_${codeStorage}`);
      localStorage.removeItem(`advertise_${codeStorage}`);
      localStorage.removeItem(`layout_${codeStorage}`);
      localStorage.removeItem(`product_${codeStorage}`);
      localStorage.removeItem(`productGroup_${codeStorage}`);
      localStorage.removeItem(`promotion_${codeStorage}`);
      localStorage.removeItem(`privateKey`);
    }
    if (utils.checkStringValid(voucherByGame)) {
      localStorage.setItem(`voucherByGame_${code}`, voucherByGame);
    } else {
      localStorage.removeItem(`voucherByGame_${code}`);
    }
    localStorage.removeItem(`position_${code}`);
    localStorage.setItem(`privateKey`, privateKey || privateKeyStore);
    localStorage.setItem("code", code);
    localStorage.setItem(`last_init_web_${code}`, moment().format("YYYY-MM-DD"));

    document.oncontextmenu = function (e) {
      e.preventDefault();
    };
    if (utils.checkStringValid(lang)) {
      i18nContanst.changeLanguage(lang);
      localStorage.setItem("lang", lang);
    }
    // Luôn luôn xóa giỏ hàng
    localStorage.removeItem(`carts_${code}`);
    // Lưu đơn hàng trong local storage
    let cachedCartStr = localStorage.getItem(`cart_${code}`);
    if (utils.checkStringValid(cachedCartStr)) {
      data.cachedCartStr = true;
      let cachedCart = JSON.parse(cachedCartStr) as CartItem;
      if (cachedCart) {
        updateCachedCart(cachedCart);
      }
    }
    // Đi trực tiếp từ app nescafe
    if (utils.checkStringValid(token)) {
      localStorage.setItem("access_token", token);
      localStorage.setItem("firstLogin", "YES");
    }

    // Có voucher code từ đối tác
    if (
      utils.checkStringValid(partnerCode) &&
      utils.checkStringValid(transactionCode) &&
      utils.checkStringValid(requestTime) &&
      utils.checkStringValid(signature)
    ) {
      let pItem = {
        partnerCode: partnerCode,
        transactionCode: transactionCode,
        requestTime: requestTime,
        signature: signature,
      };
      localStorage.setItem(`voucherByPartner_${code}`, JSON.stringify(pItem));
    }

    // Có voucher code từ hệ thống khác
    if (
      utils.checkStringValid(voucherCode) &&
      utils.checkStringValid(voucherSource)
    ) {
      let voucherLoyalty = {
        voucherCode: voucherCode,
        voucherSource: voucherSource,
      };
      localStorage.setItem(`voucherLoyalty_${code}`, JSON.stringify(voucherLoyalty));
    }

    // Lấy thông tin user khi đang có token
    localStorage.removeItem(`voucherLoyalty_${code}`);

    var vmInfoStore = localStorage.getItem(`vendingInfo_${code}`);
    if (utils.checkStringValid(vmInfoStore)) {
      data.vmInfoStore = true;
      var vmInfoApp = JSON.parse(vmInfoStore);
      if (vmInfoApp) {
        handleKeyVM(vmInfoApp.keyVMList);
      }
    }
    data.action = "init-web";
    data.time = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
    data.url = window.location.href;
    onWriteLogApp(data);

    // Alive
    if (subsource == SUBSOURCE.VM) {
      window.addEventListener("touchstart", touchHandler, false);
      timeIdAlive = setInterval(() => {
        let elmTorogo = document.getElementById("torogo");
        let elementTorogo = "";
        if (elmTorogo == null) {
          elementTorogo = "element is null";
        } else {
          elementTorogo = "full element";
        }
        let query = new URLSearchParams(window.location.search);
        let status = query.get("status");
        let dataWeb = {
          action: "auto",
          version: VersionEnum.version,
          time: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
          url: window?.location.href,
          status: status,
          elementTorogo: elementTorogo,
        };
        onWriteLogApp(dataWeb);
      }, 120000);
    }

    return () => {
      clearInterval(timeIdAlive);
    };
  }, []);

  useEffect(() => {
    const domain = window.location.hostname;
    console.log("DOMAIN", domain);

    let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;

    if (!favicon) {
      favicon = document.createElement("link") as HTMLLinkElement;
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }
    favicon.href = faviconMap[domain] || "/favicons/favicon.ico";
    document.head.appendChild(favicon);
  }, []);
  
  // Luôn chuyển hướng /?code=... về /product?code=...
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const codeParam = params.get("code");
    if (codeParam && location.pathname === "/") {
      navigate(`/product?${params.toString()}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  function touchHandler(event) {
    let data = {
      lastTouch: moment().format("YYYY-MM-DDTHH:mm:ss.SSS")
    }
    localStorage.setItem(`userTouch_${code}`, JSON.stringify(data));
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }

  function onWriteLogApp(data: any) {
    if (subsource == SUBSOURCE.VM) {
      let dataWeb = {
        command: TYPE_CAMMAND_W2A.W2A_WRITE_LOG,
        data: data,
      };
      W2A.toroW2A(JSON.stringify(dataWeb));
    }
  }

  useEffect(() => {
    // Bất cứ khi nào có thông tin của máy điều xử lý tình trạng máy và key (style / css / ...)
    if (vendingInfo) {
      localStorage.setItem(`vendingInfo_${code}`, JSON.stringify(vendingInfo));
      // Thông tin trạng thái máy
      let data = utils.getUrlByStatusVM(
        vendingInfo,
        "APP",
        subsource,
        method,
        paymentMethod
      );
      if (data) {
        if (data.statusVM) {
          updateStatusVM(data.statusVM);
        }
      }
      // UI nescafe
      if (
        vendingInfo.machineModelId == 9 &&
        vendingInfo?.vmOwnerType == OWNER_TYPE.COMPANY
      ) {
        // cafe
        var body = document.getElementsByTagName("body")[0];
        body.classList.add(FILTER_BACKGROUND.NESCAFE);
      } else {
        // normal
        var body = document.getElementsByTagName("body")[0];
        body.classList.remove(FILTER_BACKGROUND.NESCAFE);
      }
      // Key
      handleKeyVM(vendingInfo.keyVMList);
    }
  }, [vendingInfo]);

  useEffect(() => {
    // Quảng cáo
    if (advertiseList) {
      if (Array.isArray(advertiseList)) {
        if (advertiseList.length > 0) {
          localStorage.setItem(
            `advertise_${code}`,
            JSON.stringify(advertiseList)
          );
        } else {
          localStorage.removeItem(`advertise_${code}`);
        }
      } else {
        localStorage.removeItem(`advertise_${code}`);
      }
    }
  }, [advertiseList]);

  function handleKeyVM(keyList: KeyVmDto[]) {
    // Css
    let keyStyle = keyList?.find((x) => x.key == "STYLE_URL");
    if (keyStyle && keyStyle.value != "#") {
      setStyleUrl(keyStyle.value);
    } else {
      setStyleUrl(null);
    }
    // Ngôn ngữ
    let langJson = keyList?.find((x) => x.key == "LANGUAGE_JSON");
    if (langJson && utils.checkStringValid(langJson.value)) {
      let tmp = langJson.value;
      try {
        let langValue = JSON.parse(tmp);
        if (utils.checkStringValid(langValue?.vi)) {
          i18nContanst.addResourceBundle("vi", "translation", langValue?.vi);
        }
        if (utils.checkStringValid(langValue?.en)) {
          i18nContanst.addResourceBundle("en", "translation", langValue?.en);
        }
      } catch (error) { }
    }
    // Ngôn ngữ mặt định
    let langDefault = keyList?.find((x) => x.key == "LANGUAGE");
    let langStore = localStorage.getItem("lang");
    if (langDefault && utils.checkStringValid(langDefault.value) && !langStore) {
      i18nContanst.changeLanguage(langDefault.value);
      localStorage.setItem("lang", langDefault.value);
    }
  }

  return (
    <div>
      <AndroidConnect />
      <HanldeWebStomp />
      {isLoading && <Loading />}
      <React.Suspense fallback={<Loading />}>
        <Routes>
          {appRouter.map((k: any, i: number) => {
            let Page = k.component;
            return (
              <Route
                key={i}
                path={k.path}
                element={<Page />}
              />
            )
          }
          )}
          <Route path="*" Component={PageNotFound} />
        </Routes>
      </React.Suspense>
      {utils.checkStringValid(styleUrl) && (
        <link
          rel="stylesheet"
          href={styleUrl + "?t=" + new Date().getMinutes()}
        />
      )}
    </div>
  );
};

export default connector(App);

interface ErrorProps {
  children: JSX.Element;
}
interface ErrorState {
  hasError: boolean;
}

export class CustomError extends React.Component<ErrorProps, ErrorState> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo) {
    const query = new URLSearchParams(window.location.search);
    const subsource = query.get("subsource");
    if (subsource == SUBSOURCE.VM) {
      let dataWeb = {
        command: TYPE_CAMMAND_W2A.W2A_START_INIT_PAGE,
        data: {
          action: "code-error",
          url: window?.location?.href,
          note: error?.message,
          stack: error?.stack,
          errorInfo: errorInfo,
        },
      };
      W2A.toroW2A(JSON.stringify(dataWeb));
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#F5B600",
          }}
        >
          <img
            width="100%"
            height="100%"
            alt=""
            style={{ objectFit: "contain" }}
            src="https://vending-cdn.kootoro.com/static/images/error-boundary.png"
          />
        </div>
      );
    }
    return this.props.children;
  }
}
